module.exports = __webpack_public_path__ + "img/荣昌-重庆濑溪河国家湿地公园@2x.644a9d80.png";